import { Navigate, Route, Routes } from "react-router-dom";

import { AdminAuditPage } from "@/features/admin/AdminAuditPage";
import { AdminBillingPage } from "@/features/admin/AdminBillingPage";
import { AdminClinicDetailPage } from "@/features/admin/AdminClinicDetailPage";
import { AdminClinicsPage } from "@/features/admin/AdminClinicsPage";
import { AdminDashboardPage } from "@/features/admin/AdminDashboardPage";
import { AdminExamsPage } from "@/features/admin/AdminExamsPage";
import { AdminFormsPage } from "@/features/admin/AdminFormsPage";
import { AdminPatientsPage } from "@/features/admin/AdminPatientsPage";
import { AdminUsersPage } from "@/features/admin/AdminUsersPage";
import { AppShell } from "@/components/AppShell";
import { RequireAuth } from "@/components/RequireAuth";
import { LoginPage } from "@/features/auth/LoginPage";
import { DashboardPage } from "@/features/dashboard/DashboardPage";
import { ExaminationDetailPage } from "@/features/examinations/ExaminationDetailPage";
import { ExaminationListPage } from "@/features/examinations/ExaminationListPage";
import { SectionEditorPage } from "@/features/examinations/SectionEditorPage";
import { WorklistPage } from "@/features/examinations/WorklistPage";
import { LabResultEntryPage } from "@/features/laboratory/LabResultEntryPage";
import { LabWorklistPage } from "@/features/laboratory/LabWorklistPage";
import { PatientDetailPage } from "@/features/patients/PatientDetailPage";
import { PatientFormPage } from "@/features/patients/PatientFormPage";
import { PatientListPage } from "@/features/patients/PatientListPage";
import { ExaminationTypesPage } from "@/features/references/ExaminationTypesPage";
import { LabTemplatesPage } from "@/features/references/LabTemplatesPage";
import { LabTestsPage } from "@/features/references/LabTestsPage";
import { MedicationsPage } from "@/features/references/MedicationsPage";
import { Mkb10Page } from "@/features/references/Mkb10Page";
import { OrganizationsPage } from "@/features/references/OrganizationsPage";
import { ReferencesHomePage } from "@/features/references/ReferencesHomePage";
import { ReportsPage } from "@/features/reports/ReportsPage";
import { AuditLogPage } from "@/features/settings/AuditLogPage";
import { BackupsPage } from "@/features/settings/BackupsPage";
import { DeputiesPage } from "@/features/settings/DeputiesPage";
import { ProfilePage } from "@/features/settings/ProfilePage";
import { SettingsPage } from "@/features/settings/SettingsPage";
import { SyncPage } from "@/features/sync/SyncPage";
import { UserListPage } from "@/features/users/UserListPage";

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<RequireAuth />}>
        <Route element={<AppShell />}>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/patients" element={<PatientListPage />} />
          <Route path="/patients/new" element={<PatientFormPage />} />
          <Route path="/patients/:id" element={<PatientDetailPage />} />
          <Route path="/examinations" element={<ExaminationListPage />} />
          <Route path="/examinations/:id" element={<ExaminationDetailPage />} />
          <Route
            path="/examinations/:exam_id/sections/:specialty"
            element={<SectionEditorPage />}
          />
          <Route path="/worklist" element={<WorklistPage />} />
          <Route path="/laboratory" element={<LabWorklistPage />} />
          <Route path="/lab-orders/:id" element={<LabResultEntryPage />} />
          <Route path="/reports" element={<ReportsPage />} />
          <Route path="/users" element={<UserListPage />} />
          <Route path="/references" element={<ReferencesHomePage />} />
          <Route path="/references/organizations" element={<OrganizationsPage />} />
          <Route path="/references/examination-types" element={<ExaminationTypesPage />} />
          <Route path="/references/medications" element={<MedicationsPage />} />
          <Route path="/references/mkb10" element={<Mkb10Page />} />
          <Route path="/references/lab-tests" element={<LabTestsPage />} />
          <Route path="/references/lab-templates" element={<LabTemplatesPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/settings/profile" element={<ProfilePage />} />
          <Route path="/settings/deputies" element={<DeputiesPage />} />
          <Route path="/settings/audit" element={<AuditLogPage />} />
          <Route path="/settings/backups" element={<BackupsPage />} />
          <Route path="/settings/sync" element={<SyncPage />} />
          <Route path="/admin" element={<AdminDashboardPage />} />
          <Route path="/admin/clinics" element={<AdminClinicsPage />} />
          <Route path="/admin/clinics/:id" element={<AdminClinicDetailPage />} />
          <Route path="/admin/users" element={<AdminUsersPage />} />
          <Route path="/admin/patients" element={<AdminPatientsPage />} />
          <Route path="/admin/examinations" element={<AdminExamsPage />} />
          <Route path="/admin/forms" element={<AdminFormsPage />} />
          <Route path="/admin/audit" element={<AdminAuditPage />} />
          <Route path="/admin/billing" element={<AdminBillingPage />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
